import { ProductItem } from 'src/types/common/product';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
export const convertDatafromServer = (data: ProductItem) => {
  const { name, remarks, brand } = data;

  const productInfo = {
    name,
    remarks,
    brand,
  };
  const { storeUuid, status, uuid, productType } = data;
  const { tags: innerTags } = data;
  const tags = { tags: innerTags };
  //==
  const { productVariant } = data;
  const { options, variants = [] } = productVariant || {};
  const convertedVariants = variants.map((i) => {
    const { values } = i;
    return {
      ...i,
      values: values.reduce((pre, now) => {
        const { id, value } = now;
        return { ...pre, [id]: { value } };
      }, {}),
    };
  });

  //==

  return {
    productInfo,
    storeUuid,
    status,
    uuid,
    productType,
    options,
    tags,
    variants: convertedVariants,
    ...reduxUpdatedStatusControl,
  };
};
